import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//Componentes auxiliares:
import PasswordChangeModal from './PasswordChangeModal';

class UserOptionsDropdown extends React.Component {

    constructor() {
        super();

        this.state = {
            isThePasswordModalOpen: false
        }
    }


    render() {
        return (
            <React.Fragment>
                <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                    <Dropdown isOpen={this.state.dropdownIsOpen} title="OpcionesDelUsuario"
                        toggle={() => { this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen }) }}>
                        <DropdownToggle nav style={{ padding: 0 }}>
                            <i className="fas fa-ellipsis-v" style={{ paddingLeft: 15, paddingTop: 8, color: "#66615b" }} />
                        </DropdownToggle>

                        <DropdownMenu right>
                            <DropdownItem style={{ cursor: "pointer" }} onClick={this.passwordChangeModalToggle}>
                                Cambiar contraseña
                        </DropdownItem>

                            <DropdownItem style={{ cursor: "pointer" }} >
                                Solicitar cambio de perfil
                        </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>

                <PasswordChangeModal
                    isOpen={this.state.isThePasswordModalOpen}
                    modalToggle={this.passwordChangeModalToggle} />
            </React.Fragment>
        );
    }

    //Métodos operativos:
    passwordChangeModalToggle = () => {
        this.setState({ isThePasswordModalOpen: !this.state.isThePasswordModalOpen });
    }
}

export default UserOptionsDropdown;